import { useParams } from "react-router";
import { Confirmation } from "@/services/backend/rlt/confirmations/types/confirmation";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useRltConfirmationShowQuery } from "@/services/backend/rlt/confirmations/api/confirmation-api";
import t from "@/lang/lang";
import { Card } from "@/shared/components/ui/card";
import { ConfirmationDataCard } from "@/services/backend/rlt/confirmations/components/confirmation-data-card";
import { PricingCards } from "@/services/backend/rlt/pricing/components/pricing-cards";
import { PricingByAreaCard } from "@/services/backend/rlt/pricing/components/pricing-by-area-card";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";

export function ConfirmationDataRoute() {
  const { confirmationId } = useParams();

  if (!confirmationId) {
    return null;
  }

  return <ConfirmationData confirmationId={confirmationId} />;
}

function ConfirmationData({ confirmationId }: { confirmationId: string }) {
  const {
    data: confirmation,
    isLoading,
    error,
  } = useRltConfirmationShowQuery({
    id: confirmationId,
  });

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!confirmation) {
    return <div />;
  }

  return <ConfirmationDataView confirmation={confirmation} />;
}

export function ConfirmationDataView({
  confirmation,
}: {
  confirmation: Confirmation;
}) {
  return (
    <div className="space-y-2">
      <ConfirmationDataCard confirmationId={confirmation.id} />
      <PricingCards
        pricingId={confirmation.pricingId}
        disabled={confirmation.immutable}
      />
      <PricingByAreaCard
        pricingByAreaId={confirmation.pricingByAreaId}
        disabled={confirmation.immutable}
      />
      <Textblocks
        subdomain={GSMSubdomain.RLT}
        documentKind={confirmation.documentKind}
        documentId={confirmation.id}
        title={t("Bemerkungen in Auftragsbestätigung")}
        defaultOpen={false}
      />
    </div>
  );
}
